import { render, staticRenderFns } from "./place-header.vue?vue&type=template&id=0d532973&scoped=true"
import script from "./place-header.vue?vue&type=script&lang=ts"
export * from "./place-header.vue?vue&type=script&lang=ts"
import style0 from "./place-header.vue?vue&type=style&index=0&id=0d532973&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d532973",
  null
  
)

export default component.exports